
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    colorCode: {
      type: String,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    quantity: null,
    isLoading: false,
  }),
  computed: {
    maxQuantity() {
      return this.colorCode !== 'gift-card' &&
        this.product.quantityAvailable < 10
        ? this.product.quantityAvailable
        : 10
    },
  },
  watch: {
    product() {
      this.isLoading = false
      this.quantity = this.product.quantity
    },
  },
  beforeMount() {
    this.quantity = this.product.quantity
  },
  methods: {
    updateQuantity(quantity) {
      this.isLoading = true
      this.$emit('updateQty', quantity)
    },
  },
}
